{
  "common": {
    "appName": "Roster Management",
    "loading": "Loading…",
    "retry": "Try again",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "delete": "Delete",
    "edit": "Edit",
    "loadMore": "Load more",
    "notFound": "Not found",
    "somethingWentWrong": "Something went wrong",
    "offline": "Could not reach the server. Check your connection.",
    "search": "Search",
    "searchPlaceholder": "Search posts…",
    "clear": "Clear",
    "saved": "Saved",
    "noResults": "Nothing matched “{{query}}”. Try a different search.",
    "roles": {
      "admin": "Administrator",
      "member": "Member"
    }
  },
  "nav": {
    "primary": "Main",
    "openMenu": "Open navigation menu",
    "menu": "Navigation",
    "signedInAs": "Signed in as",
    "sections": {
      "workspace": "Workspace"
    }
  },
  "auth": {
    "signIn": "Sign in",
    "signOut": "Sign out",
    "signingIn": "Signing in…",
    "email": "Email",
    "password": "Password",
    "emailPlaceholder": "you@example.com",
    "welcomeTitle": "Sign in",
    "welcomeSubtitle": "Use your organization account.",
    "consoleTitle": "Operations console",
    "consoleSubtitle": "One shared core, two apps — web and mobile, always in step.",
    "demoHint": "Demo credentials: anisha@example.com / password123",
    "invalidCredentials": "That email and password combination is not recognised.",
    "forgotPassword": "Forgot your password?",
    "forgotPasswordTitle": "Reset your password",
    "forgotPasswordSubtitle": "Enter your email and we will send you a reset code.",
    "sendResetCode": "Send reset code",
    "sendingResetCode": "Sending…",
    "resetSentTitle": "Check your email",
    "resetSent": "If an account exists for {{email}}, a reset code is on its way. The code expires in 30 minutes.",
    "enterResetCode": "I have a code",
    "backToSignIn": "Back to sign in",
    "resetPasswordTitle": "Choose a new password",
    "resetPasswordSubtitle": "Paste the code from your email, then pick a new password.",
    "resetCode": "Reset code",
    "newPassword": "New password",
    "confirmPassword": "Confirm new password",
    "updatePassword": "Update password",
    "updatingPassword": "Updating…",
    "resetDoneTitle": "Password updated",
    "resetDone": "Your password was changed and every other session was signed out. Sign in with the new one.",
    "resetDemoHint": "Demo reset code: reset-code-user-1"
  },
  "posts": {
    "listTitle": "Posts",
    "countLabel_one": "{{count}} post",
    "countLabel_other": "{{count}} posts",
    "empty": "No posts yet. Create the first one.",
    "new": "New post",
    "create": "Create post",
    "editTitle": "Edit post",
    "deleteConfirm": "Delete this post? This cannot be undone.",
    "notFound": "That post does not exist, or it was deleted.",
    "byAuthor": "by {{name}}",
    "draft": "Draft",
    "published": "Published",
    "fields": {
      "title": "Title",
      "titlePlaceholder": "A short, clear title",
      "body": "Body",
      "bodyPlaceholder": "What do you want to say?",
      "published": "Publish immediately"
    }
  },
  "profile": {
    "title": "Profile",
    "subtitle": "How we reach you.",
    "displayName": "Display name",
    "email": "Email",
    "emailHint": "Contact support to change your email.",
    "phone": "Phone number",
    "phoneHint": "Required for SMS notifications.",
    "notificationChannel": "Notify me by",
    "channel": {
      "email": "Email",
      "sms": "SMS",
      "none": "Do not notify me"
    },
    "marketingOptIn": "Send me product updates",
    "save": "Save changes",
    "savedJustNow": "Saved"
  },
  "wl": {
    "brand": "Prabin Luitel",
    "signIn": {
      "phoneTitleLead": "Let’s get you ",
      "phoneTitleAccent": "signed in.",
      "phoneSubtitle": "Pop in your mobile and we’ll WhatsApp you a code.",
      "phoneLabel": "Your mobile",
      "phonePlaceholder": "412 345 678",
      "sendCode": "WhatsApp me a code",
      "help": "Stuck? We can help",
      "codeTitleLead": "Check ",
      "codeTitleAccent": "WhatsApp.",
      "codeSubtitle": "If {{phone}} is registered with us, a 6-digit code is on its way. It expires in 10 minutes.",
      "codeLabel": "Your code",
      "wrongNumber": "Wrong number?",
      "nothingYet": "Nothing yet?",
      "resend": "Resend code",
      "resendIn": "Resend in {{seconds}}s",
      "verify": "Sign me in",
      "otpDigit": "Digit {{index}} of 6"
    },
    "tabs": {
      "home": "Home",
      "events": "Event",
      "addShift": "Add Shift",
      "staff": "Staffs",
      "settings": "Settings"
    },
    "home": {
      "greetingMorning": "Good morning",
      "greetingAfternoon": "Good afternoon",
      "greetingEvening": "Good evening",
      "summaryNone": "Nothing on yet. Add an event and the week fills itself in.",
      "summaryOne": "{{count}} shift still needs people.",
      "summaryOther": "{{count}} shifts still need people.",
      "summaryReady": "Every open shift is covered. Nice.",
      "statEvents": "Events this week",
      "statToFill": "Shifts to fill",
      "statConfirmed": "Confirmed this week",
      "statAwaiting": "Awaiting reply",
      "needsAttention": "Needs attention",
      "allCovered": "All open shifts are covered.",
      "attentionCountOne": "1 event",
      "attentionCountOther": "{{count}} events",
      "comingUp": "Coming up",
      "allEvents": "All events",
      "noUpcoming": "Nothing scheduled — tap Add Shift to plan the next event.",
      "rosterLineNone": "No staff on the roster yet.",
      "rosterLine": "{{count}} people on the roster · {{lists}}",
      "listsNone": "no priority lists",
      "listsOne": "1 priority list",
      "listsOther": "{{count}} priority lists"
    },
    "homeStat": {
      "eventsSub": "This week, Monday to Sunday",
      "toFillSub": "Open events, from today on",
      "confirmedSub": "Said yes this week, Monday to Sunday",
      "awaitingSub": "Messaged, and no reply yet",
      "eventsEmpty": "No events this week.",
      "toFillEmpty": "Every open shift is covered.",
      "confirmedEmpty": "Nobody has confirmed a shift this week yet.",
      "awaitingEmpty": "Nobody is waiting to reply.",
      "shiftsShortOne": "1 shift short",
      "shiftsShortOther": "{{count}} shifts short",
      "unknownPerson": "Former staff member"
    },
    "events": {
      "title": "Events",
      "add": "Add Event",
      "modeDay": "Day",
      "modeWeek": "Week",
      "modeMonth": "Month",
      "previous": "Previous range",
      "next": "Next range",
      "jumpToday": "Jump to today",
      "countOne": "1 event {{range}}",
      "countOther": "{{count}} events {{range}}",
      "shiftsNone": "no shifts",
      "shiftsOne": "1 shift",
      "shiftsOther": "{{count}} shifts",
      "emptyRange": "No events {{range}}.",
      "statusComplete": "Complete",
      "statusReady": "Ready",
      "statusNoShifts": "No shifts",
      "statusNeed": "Need {{count}}",
      "select": "Select events",
      "selectCancel": "Cancel",
      "selectTitleNone": "Select events",
      "selectTitleOne": "1 event selected",
      "selectTitleOther": "{{count}} events selected",
      "selectAll": "Select all shown",
      "selectedElsewhere": "Also selected",
      "notSelectable": "Nobody to message",
      "sendOne": "Send requests for 1 event",
      "sendOther": "Send requests for {{count}} events"
    },
    "staff": {
      "title": "Staffs",
      "add": "Add staff",
      "searchPlaceholder": "Search name, job or city",
      "clearSearch": "Clear search",
      "countOne": "1 person on the roster",
      "countOther": "{{count}} people on the roster",
      "noMatch": "No one matches “{{query}}”.",
      "tagPriority": "Priority",
      "tagUsual": "Usual",
      "formNewTitle": "Add staff",
      "formEditTitle": "Edit staff",
      "fieldName": "Employee name",
      "fieldNamePlaceholder": "Full name",
      "fieldJob": "Job",
      "jobBowlClean": "Bowl Clean",
      "jobUnspecified": "Undefined",
      "jobDayClean": "Day Clean",
      "jobEventClean": "Event Clean",
      "jobSupervisor": "Supervisor",
      "jobPostClean": "Post Clean",
      "fieldWhatsapp": "WhatsApp number",
      "phonePlaceholder": "4XX XXX XXX",
      "fieldCity": "City",
      "fieldCityPlaceholder": "e.g. Parramatta",
      "fieldGender": "Gender",
      "genderFemale": "Female",
      "genderMale": "Male",
      "genderOther": "Other",
      "fieldHours": "Maximum hours allowed",
      "hoursUnlimited": "Unlimited",
      "hoursFortnight": "Hours per FN",
      "hoursSuffix": "hours per fortnight",
      "hoursPlaceholder": "0",
      "fieldAvailability": "Availability",
      "availabilityPlaceholder": "e.g. Mon–Fri mornings, not public holidays",
      "fieldPriority": "Priority for shifts",
      "priorityOff": "Off",
      "priorityUsual": "Usual",
      "priorityPrioritised": "Prioritised",
      "priorityHintOff": "Listed normally",
      "priorityHintUsual": "Listed near the top for matching shifts",
      "priorityHintPriority": "Listed first for matching shifts",
      "bandsLabel": "Shift times this applies to",
      "bandEarly": "Early",
      "bandDay": "Day",
      "bandEvening": "Evening",
      "bandNight": "Night",
      "saveNew": "Add to staff",
      "saveEdit": "Save changes",
      "remove": "Remove from staff",
      "shiftsLink": "Confirmed shifts",
      "shiftsLinkSub": "What {{name}} said yes to — and send them several events at once",
      "errName": "Enter the employee’s name.",
      "errWhatsapp": "Enter an Australian or Nepali mobile, e.g. +61 412 345 678 or +977 981 234 5678.",
      "errHours": "Enter the hours allowed per fortnight.",
      "errBands": "Pick at least one shift time this applies to.",
      "unlimitedHours": "Unlimited hrs",
      "hoursPerFn": "{{count}} hrs / FN"
    },
    "staffShifts": {
      "titleFallback": "Confirmed shifts",
      "subtitle": "Confirmed shifts",
      "upcoming": "Upcoming",
      "past": "Past",
      "emptyUpcoming": "No upcoming shifts confirmed.",
      "emptyPast": "No past shifts yet.",
      "notMessaged": "Not messaged yet",
      "nothingToSend": "Nothing waiting to send. Add them to an event below.",
      "addToEvent": "Add to another event",
      "sendHint": "Tick events and send — {{name}} gets one message listing them all, and nobody else is messaged. Up to {{count}} at a time.",
      "limitHit": "{{count}} events is the most one message can hold.",
      "sendOne": "Send 1 event to {{name}}",
      "sendOther": "Send {{count}} events to {{name}}",
      "pickShiftSub": "Put {{name}} on a shift on {{date}}. Nobody is messaged until you send.",
      "takeOff": "Take off",
      "started": "Started",
      "optedOut": "{{name}} has opted out of messages, so nothing can be sent to them from here."
    },
    "settings": {
      "title": "Settings",
      "sectionProfile": "Profile",
      "sectionStaff": "Staff",
      "signedInOn": "Signed in on this iPhone",
      "managerTitle": "Report manager",
      "managerNotSet": "Not set — add one before sending a report",
      "exStaffTitle": "Ex Staffs",
      "exStaffSubtitle": "Removed staff you can bring back",
      "listsTitle": "Priority lists",
      "listsSubtitle": "Named groups to add to a shift in one tap",
      "signOut": "Sign out",
      "managerName": "Name",
      "managerNamePlaceholder": "Manager’s name",
      "managerPhone": "WhatsApp number",
      "managerSave": "Save",
      "managerErrPhone": "Enter an Australian or Nepali mobile, e.g. +61 412 345 678 or +977 981 234 5678.",
      "managerErrSave": "Couldn’t save the manager. Check your connection and try again.",
      "sectionMessages": "Messages",
      "templatesTitle": "Message templates",
      "templatesSubtitle": "The roster message, the manager report, and your own"
    },
    "templates": {
      "title": "Message templates",
      "new": "New",
      "sectionBuiltIn": "Sent by the app",
      "sectionCustom": "Your templates",
      "rosterMessage": "Roster message",
      "rosterMessageHint": "Asks staff about their shifts",
      "managerReport": "Manager report",
      "managerReportHint": "The finished roster, to your manager",
      "pillDefault": "Default",
      "pillEdited": "Edited",
      "empty": "No templates yet. Make one here, or save a message you write when you message staff from an event.",
      "formNewTitle": "New template",
      "formEditTitle": "Edit template",
      "fieldName": "Name",
      "fieldNamePlaceholder": "e.g. Parking",
      "fieldBody": "Message",
      "fieldBodyPlaceholder": "Hi {name}, …",
      "fillInsLabel": "Fill-ins",
      "fillInsHint": "Tap to add — each person gets their own",
      "fillInsRequired": "Must stay in: {{list}}",
      "previewLabel": "Preview",
      "previewHint": "Highlighted parts are filled in for each person.",
      "builtInNote": "Edits change the text sent from your WhatsApp number. While Meta WhatsApp is on, Meta sends its approved wording instead.",
      "save": "Save",
      "delete": "Delete template",
      "reset": "Reset to default",
      "resetTitle": "Go back to the default wording?",
      "resetBody": "Your changes to this message are replaced by the app’s own wording.",
      "resetConfirm": "Reset",
      "errSave": "Couldn’t save the template. Check your connection and try again.",
      "errDelete": "Couldn’t delete the template. Check your connection and try again.",
      "fillIn": {
        "name": "First name",
        "event": "Event",
        "date": "Date",
        "time": "Start time",
        "shifts": "Their shifts",
        "link": "Their link",
        "roster": "Roster"
      }
    },
    "notice": {
      "action": "Message staff",
      "title": "Message staff",
      "startFrom": "Start from",
      "writeOwn": "Write your own",
      "fieldBody": "Message",
      "fieldBodyPlaceholder": "Write your message…",
      "sendTo": "Send to",
      "chipConfirmed": "Confirmed · {{count}}",
      "chipAwaiting": "Awaiting reply · {{count}}",
      "chipDeclined": "Declined · {{count}}",
      "noRecipients": "Pick who should get it.",
      "previewFor": "What {{name}} gets",
      "sendOne": "Send to 1 person",
      "sendOther": "Send to {{count}} people",
      "saveAsTemplate": "Save as template",
      "templateName": "Template name",
      "templateNamePlaceholder": "e.g. Running late",
      "saveTemplate": "Save template",
      "savedTemplate": "Saved to your templates.",
      "errSend": "Couldn’t send. Check your connection and try again."
    },
    "lists": {
      "title": "Priority lists",
      "new": "New list",
      "countNone": "None yet",
      "countOne": "1 list",
      "countOther": "{{count}} lists",
      "empty": "No lists yet. Group people you often roster together — “Stadium crew”, “Weekend regulars” — and add the whole list to a shift in one tap.",
      "noMembers": "No one added yet",
      "formNewTitle": "New list",
      "formEditTitle": "Edit list",
      "fieldTitle": "List name",
      "fieldTitlePlaceholder": "e.g. Stadium crew",
      "people": "People",
      "emptyMembers": "No one on this list yet.",
      "addPeople": "Add people",
      "save": "Save list",
      "delete": "Delete list",
      "errTitle": "Give the list a name.",
      "removeMember": "Remove {{name}} from the list"
    },
    "exStaff": {
      "title": "Ex Staffs",
      "restore": "Restore",
      "empty": "No ex staff yet. Anyone you remove from Staffs lands here, ready to bring back.",
      "meta": "Left {{date}} · {{job}}",
      "countOne": "1 person",
      "countOther": "{{count}} people"
    },
    "addShift": {
      "title": "Add shift",
      "eventLabel": "Event",
      "choose": "Choose an event",
      "eventCountOne": "1 upcoming event",
      "eventCountOther": "{{count}} upcoming events",
      "noEventOptions": "No upcoming events yet. Create one to add shifts to.",
      "newEvent": "New event",
      "batchLabel": "In this batch",
      "batchCountOne": "1 shift queued",
      "batchCountOther": "{{count}} shifts queued",
      "newShifts": "New shifts",
      "existingNone": "No shifts yet",
      "existingOne": "1 shift already",
      "existingOther": "{{count}} shifts already",
      "emptyRows": "No shifts yet. Add the first start time — you’ll pick staff next.",
      "shiftN": "Shift {{n}}",
      "removeRow": "Remove",
      "startTime": "Start time",
      "minPeople": "Min. people",
      "staffLabel": "Staff",
      "noStaffPicked": "No one picked yet",
      "fillLabel": "{{picked}} of {{min}}",
      "addRow": "Add shift",
      "createOne": "Create 1 shift",
      "createOther": "Create {{count}} shifts",
      "errNoRows": "Add at least one shift before creating.",
      "promptTitle": "Shift start time",
      "promptBody": "Pick when this shift begins. You’ll choose staff next.",
      "promptCancel": "Cancel",
      "promptNext": "Next",
      "timeDone": "Done"
    },
    "eventForm": {
      "title": "Add event",
      "subInline": "Create it, then add the shift.",
      "name": "Event name",
      "namePlaceholder": "e.g. Stadium bowl clean",
      "type": "Type",
      "typeHint": "Every event is at the stadium",
      "typeStadium": "Stadium",
      "date": "Date",
      "footnote": "Shifts and staff come later — use Add Shift once the month is in.",
      "save": "Save event",
      "errName": "Give the event a name.",
      "errDate": "Pick a date for the event.",
      "dateChange": "Change date",
      "datePickerTitle": "Event date",
      "dateConfirm": "Done"
    },
    "picker": {
      "titleForm": "Select staff",
      "titleRequest": "Request more people",
      "titleList": "Add to list",
      "subForm": "{{count}} selected · needs {{min}}",
      "subRequest": "{{assigned}} already asked",
      "subList": "{{count}} on this list",
      "searchPlaceholder": "Search by name",
      "clearSearch": "Clear search",
      "addAList": "Add a list",
      "autoHint": "Prioritised and usual staff for {{band}} shifts ({{range}}) are listed first — nobody is selected for you.",
      "noMatch": "No one matches “{{query}}”.",
      "noActive": "No active staff yet — add people in Staffs first.",
      "emptyPool": "Everyone on the roster has already been asked for this shift.",
      "onShift": "On the {{time}} shift",
      "oneShiftHint": "People already on another shift of this event are greyed out — each person works one shift per event.",
      "selectedOne": "1 selected",
      "selectedOther": "{{count}} selected",
      "needMoreOne": "1 more to reach the minimum",
      "needMoreOther": "{{count}} more to reach the minimum",
      "minMet": "Minimum met",
      "filterEveryone": "Everyone",
      "filterSelected": "Selected · {{count}}",
      "noneSelected": "Nobody is selected yet. Switch to Everyone to pick people.",
      "done": "Done",
      "continue": "Continue"
    },
    "detail": {
      "back": "Back to events",
      "subtitle": "{{type}}{{date}}",
      "complete": "Complete",
      "shiftFill": "{{confirmed}} of {{min}} confirmed",
      "noneAssigned": "No one assigned yet.",
      "requestMore": "Request more people",
      "addShift": "Add shift",
      "noShifts": "No shifts yet. Add the first start time and pick staff.",
      "replyHint": "Replies arrive from WhatsApp automatically. Tap a person to mark their response yourself, record a message you sent by hand, or send a reminder — or tap their copy icon to send them the message by hand. The reply link in it still works.",
      "statusConfirmed": "Confirmed",
      "statusDeclined": "Declined",
      "statusAwaiting": "Awaiting reply",
      "statusNone": "No response",
      "msgSent": "Message sent",
      "msgNotSent": "Not messaged yet",
      "msgQueued": "Waiting to send",
      "msgReminderQueued": "Reminder waiting to send",
      "copyNone": "Couldn’t find a message for {{name}} to copy.",
      "copyOptedOut": "{{name}} has opted out of messages.",
      "completeRoster": "Complete roster",
      "shortOne": "1 shift still needs attention",
      "shortOther": "{{count}} shifts still need attention",
      "reopen": "Reopen roster",
      "sendReport": "Send report to manager",
      "sendReportAgain": "Send report again",
      "reportSending": "Sending the report to the manager…",
      "reportSent": "Sent to the manager · {{when}}",
      "reportDelivered": "Delivered to the manager · {{when}}",
      "reportRead": "Read by the manager · {{when}}",
      "reportFailed": "The report didn’t reach the manager — send it again.",
      "viewReport": "Report to manager",
      "markTitle": "{{name}}",
      "markSub": "Mark their reply for {{time}}.",
      "markYes": "Confirmed — they’re coming",
      "markNo": "Declined — can’t make it",
      "markClear": "No response yet",
      "markSent": "Message sent — waiting for reply",
      "remind": "Send reminder",
      "remindSub": "Same message and link, headed REMINDER",
      "remindNoLink": "There’s no stored link to repeat — this message was sent by hand. Forward the original from your phone instead.",
      "confirmTitle": "Complete this roster?",
      "confirmBody": "It moves to Complete and stops asking for people. You can reopen it later if something changes.",
      "confirmBodyUnasked": "{{count}} assigned {{people}} not been messaged yet. Completing now leaves them unasked — you can still message them afterwards.",
      "confirmCancel": "Not yet",
      "confirmYes": "Complete roster",
      "confirmTitleShort": "Complete a short roster?",
      "confirmBodyShort": "Not every shift has enough confirmed staff. Completing now stops asking for people and records the roster as short-staffed. You can reopen it later.",
      "confirmShortLine": "{{time}} — {{confirmed}} of {{min}} confirmed",
      "confirmYesShort": "Complete anyway",
      "completeChanged": "The roster changed since you opened it. Close this and check the shifts again.",
      "noShiftsToComplete": "Add a shift before completing this roster",
      "deleteEvent": "Delete event",
      "deleteTitle": "Delete this event?",
      "deleteBody": "{{name}} on {{date}} and its shifts will be removed. Nobody has been messaged about it, so there is no one to tell.",
      "deleteKeep": "Keep it",
      "deleteYes": "Delete event"
    },
    "send": {
      "previewTitle": "Message preview",
      "previewSub": "{{count}} people will get this",
      "messageLabel": "WhatsApp message",
      "tokenCode": "code",
      "tokenHint": "Highlighted parts are filled in for each person — the link opens their shifts to confirm.",
      "recipients": "Recipients",
      "recipientCountOne": "1 person",
      "recipientCountOther": "{{count}} people",
      "noRecipients": "No staff assigned yet — go back and select people for each shift.",
      "sendOne": "Send 1 message",
      "sendOther": "Send {{count}} messages",
      "saveWithout": "Save without sending",
      "sendingTitle": "Sending messages…",
      "allSent": "All messages sent",
      "someFailed": "Some messages failed",
      "progress": "{{sent}} of {{total}} sent",
      "statusQueued": "Queued",
      "statusSending": "Sending",
      "statusSent": "Sent",
      "statusFailed": "Failed",
      "retry": "Retry",
      "retryAllOne": "Retry 1 failed message",
      "retryAllOther": "Retry {{count}} failed messages",
      "done": "Done",
      "shiftMeta": "{{time}} · {{job}}",
      "copyOne": "Copy",
      "copiedOne": "Copied",
      "copyHint": "Copy a message to send it by hand — the reply link in it still works.",
      "copyFor": "Copy the message for {{name}}",
      "eventsLabel": "Events",
      "previewSubEvents": "{{count}} events",
      "previewSubPerson": "{{count}} events, only to {{name}}",
      "sendEventsOne": "Send requests for 1 event",
      "sendEventsOther": "Send requests for {{count}} events",
      "tokenHintMany": "Highlighted parts are filled in per person — their events, dates and shifts, and a link that records their answers.",
      "copyHintPreview": "Tap a copy icon to send that person’s message by hand. Copying doesn’t mark anyone as asked, and reopening this screen mints new links — send the ones you copy here.",
      "copyAssigns": "Copying a message puts that person on the shift, so the reply link in it works. Nobody is messaged by it.",
      "copySaved": "Saved, and nobody has been messaged. Copy each message and send it yourself — the reply link in it still records their answer.",
      "pacingEta_one": "Sending one at a time to protect your number · about {{count}} minute left",
      "pacingEta_other": "Sending one at a time to protect your number · about {{count}} minutes left",
      "pacingSoon": "Sending one at a time to protect your number · almost done",
      "heldQuiet": "Held overnight — sending from {{time}}",
      "heldLimit": "Daily sending limit reached — resumes {{time}}",
      "heldSender": "Paused — the WhatsApp number is disconnected. Messages go once it’s back.",
      "keepSending": "Keep sending in background",
      "nextIn_one": "Next message in {{count}} second",
      "nextIn_other": "Next message in {{count}} seconds",
      "nextGoing": "Sending the next message…",
      "compactNext_one": "next in {{count}} second",
      "compactNext_other": "next in {{count}} seconds",
      "compactGoing": "sending now",
      "compactFailed": "{{count}} failed",
      "compactQuiet": "held until {{time}}",
      "compactLimit": "daily limit — resumes {{time}}",
      "compactDown": "paused — WhatsApp disconnected"
    },
    "report": {
      "title": "Report to manager",
      "to": "To",
      "change": "Change",
      "noManager": "No manager set",
      "addManager": "Add one",
      "messageLabel": "WhatsApp message",
      "send": "Send via WhatsApp",
      "sending": "Sending…",
      "sentTo": "Sent to {{name}} on WhatsApp",
      "sendFailed": "Couldn’t send the report. Pull down to refresh, then try again.",
      "done": "Done",
      "copy": "Copy message",
      "copied": "Copied — paste it anywhere"
    },
    "common": {
      "back": "Back",
      "close": "Close",
      "cancel": "Cancel",
      "linkBase": "wlaus.app/r",
      "phoneHint": "Australian (04…) or Nepali (98…) mobile",
      "paste": "Paste",
      "pastePhone": "Paste a copied phone number"
    },
    "respond": {
      "loading": "Loading your shifts…",
      "askTitle_one": "Can you work this shift, {{name}}?",
      "askTitle_other": "Can you work these {{count}} shifts, {{name}}?",
      "askSub_one": "Choose an answer, then submit.",
      "askSub_other": "Choose an answer for every shift, then submit them together.",
      "inTitle": "You’re on the roster, {{name}}.",
      "inSub": "Thanks — you’re down to work. Your WhatsApp message has the arrival and uniform details.",
      "finalSub": "The roster is final, so answers can’t be changed now. If something comes up, tell your supervisor.",
      "outTitle": "Thanks for letting us know.",
      "outSub": "No worries — we’ll ask again for the next one.",
      "closedTitle_one": "This shift has been filled.",
      "closedTitle_other": "These shifts have been filled.",
      "closedSub": "Thanks for being quick — we’ll be in touch for the next one.",
      "yes": "Yes, I’m in",
      "no": "Can’t make it",
      "confirmed": "You’re confirmed",
      "confirmedFinal": "You’re confirmed — the roster is final",
      "declined": "You can’t make this one",
      "filled": "Filled — no longer needed",
      "progress": "{{answered}} of {{total}} answered",
      "progressDone": "All answered",
      "progressYes": "{{count}} yes",
      "hintReady": "All answered — ready to send.",
      "hintChoose": "Choose an answer to continue",
      "hintLeft_one": "{{count}} of {{total}} shifts still needs an answer",
      "hintLeft_other": "{{count}} of {{total}} shifts still need an answer",
      "submit_one": "Submit answer",
      "submit_other": "Submit answers",
      "submitting": "Sending…",
      "sent": "Answers sent to {{brand}}",
      "calendar_one": "Add to calendar",
      "calendar_other": "Add {{count}} shifts to calendar",
      "change": "Change my answers",
      "failed": "Some answers didn’t save. Check your signal and try again.",
      "locked": "The roster has just been finalised, so answers can’t be changed now.",
      "expiredTitle": "This link has expired.",
      "expiredSub": "It may have been cancelled or replaced by a newer message.",
      "expiredCardTitle": "Need a fresh link?",
      "expiredCardBody": "Ask your supervisor to send you a new one.",
      "startedTitle": "Your shift has started.",
      "startedSub": "This link stopped working when the shift began. If something’s wrong, call your supervisor.",
      "notFoundTitle": "We couldn’t find this shift request.",
      "notFoundSub": "Check the link in your message, or ask your supervisor.",
      "errorTitle": "We couldn’t load your shifts.",
      "errorSub": "Check your signal and try again.",
      "retry": "Try again",
      "personal": "{{brand}} sent you this link because you’re on the roster. It’s personal — please don’t forward it."
    },
    "status": {
      "ready": "Ready",
      "need": "Need {{count}}",
      "noShifts": "No shifts",
      "complete": "Complete",
      "cancelled": "Cancelled"
    },
    "plan": {
      "stepDates": "Step 1 of 4 · Dates",
      "stepCards": "Step 2 of 4 · Details",
      "stepReview": "Step 3 of 4 · Review",
      "stepSend": "Step 4 of 4 · Message staff",
      "titleDates": "Pick the dates",
      "titleCards": "Events & shifts",
      "titleReview": "Check everything",
      "titleSaved": "Saved",
      "subDates": "Tap every day you’re planning — you can pick across months.",
      "subCards": "Swipe left for the next date, right for the previous.",
      "subReview": "Nothing is saved to WL Aus until you tap Save.",
      "subSaved": "Send each person their shifts on WhatsApp.",
      "draftSaved": "Draft saved",
      "restoredOne": "Draft restored · 1 date",
      "restoredOther": "Draft restored · {{count}} dates",
      "previousMonth": "Previous month",
      "nextMonth": "Next month",
      "legend": "A dot means that date already has an event name.",
      "selected": "Selected",
      "clearDraft": "Clear draft",
      "removeDate": "Remove {{date}}",
      "pickedNone": "No dates yet",
      "pickedOne": "1 date selected",
      "pickedOther": "{{count}} dates selected",
      "pastHint": "Past days can’t be picked",
      "next": "Next",
      "cardPosition": "{{date}} · {{n}} of {{total}}",
      "statusReady": "Ready",
      "statusInProgress": "In progress",
      "copyFrom": "Copy from {{date}}",
      "copyOther": "Copy another event",
      "copyTitle": "Copy an event",
      "copyOnto": "Onto {{date}}",
      "copyNote": "Copies its name, shift times, minimums and staff. Anyone now in Ex Staffs is left off.",
      "copyReplaces": "It replaces what’s already on this date.",
      "copySearch": "Search events",
      "copyInPlan": "In this plan",
      "copySaved": "Saved events",
      "copyMeta": "{{date}} · {{shifts}}",
      "copyEmpty": "No other events with shifts yet.",
      "copyNoMatch": "No event matches “{{query}}”.",
      "copyLoadError": "Couldn’t load your events.",
      "copyRetry": "Try again",
      "copyError": "Couldn’t copy that event — try again.",
      "eventName": "Event name",
      "eventNamePlaceholder": "e.g. Stadium bowl clean",
      "shifts": "Shifts",
      "shiftCountOne": "1 shift",
      "shiftCountOther": "{{count}} shifts",
      "noShifts": "No shifts yet for this date.",
      "shiftStart": "Shift {{n}} · start",
      "minStaff": "Min.",
      "removeShift": "Remove shift {{n}}",
      "chooseStaff": "Choose staff",
      "pickedOnePerson": "1 person picked",
      "pickedPeople": "{{count}} people picked",
      "staffAndMore": "{{names}} +{{count}}",
      "fill": "{{picked}}/{{min}}",
      "addShift": "Add shift",
      "timeDone": "Done",
      "previousCard": "Previous date",
      "nextCard": "Next · {{date}}",
      "review": "Review",
      "reviewAll": "Review all",
      "goToCard": "Go to {{date}}",
      "issuePast": "This date has passed — remove it on the dates step",
      "issueName": "Add an event name",
      "issueShifts": "Add at least one shift",
      "issueDouble": "Someone is on two shifts — each person works one shift per event",
      "statEvents": "events",
      "statShifts": "shifts",
      "statStaff": "staff to message",
      "incompleteOne": "1 date needs details before you can save.",
      "incompleteOther": "{{count}} dates need details before you can save.",
      "underOne": "1 shift has fewer staff than the minimum. You can still save and request more later.",
      "underOther": "{{count}} shifts have fewer staff than the minimum. You can still save and request more later.",
      "saveError": "Couldn’t reach WL Aus. Your draft is still on this phone — try again.",
      "noName": "No event name",
      "shiftMeta": "min {{min}} · {{names}}",
      "noStaffYet": "no staff yet",
      "edit": "Edit",
      "savedBadge": "Saved",
      "saveOne": "Save 1 event",
      "saveOther": "Save {{count}} events",
      "saving": "Saving to WL Aus…",
      "nextStepNote": "You’ll message staff on the next step.",
      "savedOne": "1 event saved",
      "savedOther": "{{count}} events saved",
      "savedSub": "{{shifts}} · {{range}}",
      "messageLabel": "WhatsApp message",
      "recipients": "Recipients",
      "peopleOne": "1 person",
      "peopleOther": "{{count}} people",
      "noRecipients": "No staff were assigned, so there’s no one to message yet.",
      "batchNote": "{{count}} events go out in groups of 10, so someone with shifts in two groups gets two messages.",
      "sendOne": "Send to 1 staff member",
      "sendOther": "Send to {{count}} staff",
      "sendingStart": "Starting the send…",
      "sendError": "Couldn’t start the send. Nothing was lost — try again.",
      "notNow": "Not now — message them later",
      "done": "Done"
    },
    "sender": {
      "section": "WhatsApp",
      "statusLabel": "Sender",
      "state": {
        "ready": "Connected",
        "untracked": "Connected",
        "starting": "Starting up",
        "needs_qr": "Needs re-linking",
        "disconnected": "Disconnected",
        "needs_action": "Needs attention",
        "failed": "Not working",
        "unreachable": "Can’t reach the sender",
        "unknown": "Status unknown"
      },
      "restricted": "Restricted by WhatsApp",
      "restrictedUntil": "Restricted by WhatsApp until {{time}}",
      "waiting_one": "{{count}} message waiting",
      "waiting_other": "{{count}} messages waiting",
      "nothingWaiting": "Nothing waiting",
      "bannerDownTitle": "WhatsApp messages are paused",
      "bannerDownBody": "The sender is disconnected or restricted. Messages are waiting and will go once it’s back.",
      "bannerHeld_one": "{{count}} message waiting to send",
      "bannerHeld_other": "{{count}} messages waiting to send"
    },
    "queue": {
      "title": "Waiting messages",
      "section": "Waiting",
      "sendNow": "Send now",
      "sendNowHint": "Sends the next one now instead of waiting out the gap. The rest still go one at a time, so WhatsApp doesn’t flag your number.",
      "empty": "Nothing waiting — every message has gone.",
      "next": "Next",
      "retrying": "Retrying",
      "toManager": "Your manager",
      "shiftRequest": "Shift request",
      "report": "Roster report",
      "notice": "Message"
    },
    "reconnect": {
      "button": "Reconnect WhatsApp",
      "title": "Reconnect WhatsApp",
      "intro": "Get a code to type on the phone that has this WhatsApp number — no QR code, no dashboard.",
      "phoneLabel": "WhatsApp number",
      "getCode": "Get code",
      "starting": "Starting WhatsApp… this can take up to a minute.",
      "codeLabel": "Your code",
      "copy": "Copy code",
      "copied": "Copied",
      "step1": "On the phone with this WhatsApp, open Linked devices — in Settings on iPhone, or the ⋮ menu on Android.",
      "step2": "Tap Link a device, then Link with phone number instead.",
      "step3": "Type this code.",
      "waiting": "Waiting for WhatsApp to link…",
      "newCode": "Get a new code",
      "connected": "Connected — messages will start going again.",
      "done": "Done",
      "startFailed": "WhatsApp didn’t start. Try again in a minute."
    }
  },
  "landing": {
    "nav": {
      "signIn": "Sign in"
    },
    "eyebrow": "Rostering on WhatsApp",
    "title": "Fill every shift without the phone tag.",
    "subtitle": "Add an event, choose your people, and send the shift details on WhatsApp. Staff confirm with one tap — no app to install, no account to remember.",
    "ctaPrimary": "Sign in",
    "ctaSecondary": "See how it works",
    "preview": {
      "label": "Example WhatsApp message",
      "greeting": "Hi Ama,",
      "heading": "SHIFT DETAILS – AFTERPAY ARENA",
      "shift": "• Sunday, 27 September — 11:45 PM",
      "button": "Confirm shifts",
      "confirmed": "Ama confirmed",
      "coverage": "6 of 8 filled"
    },
    "howTitle": "How it works",
    "howSubtitle": "Three steps from an empty roster to a covered event.",
    "steps": {
      "event": {
        "title": "Add the event",
        "body": "Set the venue, the date and how many people each shift needs."
      },
      "send": {
        "title": "Send on WhatsApp",
        "body": "Everyone you pick gets their shifts, the arrival time and the uniform in one message."
      },
      "confirm": {
        "title": "Staff tap to confirm",
        "body": "Each reply lands on the roster as it arrives, so you can see who is in and what is still open."
      }
    },
    "featuresTitle": "Built for the people running the shift",
    "features": {
      "whatsapp": {
        "title": "Where your staff already are",
        "body": "Messages go out on WhatsApp, the app your team already opens a dozen times a day."
      },
      "live": {
        "title": "Coverage at a glance",
        "body": "See which shifts still need people and who has not replied yet, without chasing anyone."
      },
      "report": {
        "title": "One tap to report",
        "body": "Send your manager a clean roster summary the moment an event is covered."
      }
    },
    "footer": "© {{year}} Hiti Labs. All rights reserved.",
    "footerPrivacy": "Privacy"
  },
  "legal": {
    "backHome": "Back to home",
    "privacy": {
      "title": "Privacy policy",
      "updated": "Last updated {{date}}",
      "intro": "Roster Management is operated by Hiti Labs (“we”, “us”). This policy explains what we collect when you use the Roster Management app, the website at roster.hitilabs.com, and the WhatsApp messages we send on behalf of the teams that use it.",
      "sections": {
        "collect": {
          "title": "What we collect",
          "p1": "If you are rostered for shifts: your name, your mobile number, the shifts you are offered, and your answers.",
          "p2": "If you coordinate or manage a roster: your name, the mobile number or email you sign in with, and the events, staff lists and rosters you create.",
          "p3": "When you use the service: when a shift link is opened, the device and browser details needed to show the page, and error reports that help us fix problems."
        },
        "use": {
          "title": "How we use it",
          "p1": "We use this information to send shift details and sign-in codes over WhatsApp, record who is available, show coordinators who is rostered, send roster summaries to managers, and keep the service secure.",
          "p2": "We do not sell your information, use it for advertising, or send you marketing messages."
        },
        "whatsapp": {
          "title": "WhatsApp messages",
          "p1": "Messages are delivered through the WhatsApp Business Platform, operated by Meta. Meta processes your phone number and the message content under its own terms and privacy policy.",
          "p2": "Reply STOP to any message and we will stop messaging you. Your coordinator is told so they can reach you another way."
        },
        "share": {
          "title": "Who can see it",
          "p1": "The team that rosters you — your coordinator and their manager — can see your details and your answers.",
          "p2": "We share information with the providers that run the service for us (hosting, database, error monitoring and Meta for WhatsApp), and when the law requires it. Nobody else."
        },
        "retention": {
          "title": "How long we keep it",
          "p1": "We keep your information while your team uses Roster Management. Shift links stop working once the shift starts. Sign-in codes expire after 10 minutes and are stored only in a scrambled (hashed) form.",
          "p2": "Ask us and we will delete your information, unless we have to keep something by law."
        },
        "security": {
          "title": "Keeping it safe",
          "p1": "Everything travels over encrypted connections. Shift links are long random codes that cannot be guessed, and sign-in codes are never stored in readable form."
        },
        "storage": {
          "title": "Cookies and browser storage",
          "p1": "The website stores a small amount of information in your browser so it works properly, such as keeping you signed in. We do not use advertising or tracking cookies."
        },
        "rights": {
          "title": "Your choices",
          "p1": "You can ask to see, correct or delete the information we hold about you. Email us at {{email}} and we will reply within 30 days."
        },
        "children": {
          "title": "Children",
          "p1": "Roster Management is a workplace tool and is not directed at children under 16."
        },
        "changes": {
          "title": "Changes to this policy",
          "p1": "If we change this policy we will update this page and the date at the top."
        },
        "contact": {
          "title": "Contact us",
          "p1": "Questions about your privacy? Email {{email}}."
        }
      }
    }
  },
  "reportPage": {
    "eyebrow": "Roster report",
    "live": "Live — reopen this page to see the latest replies.",
    "rostered_one": "{{count}} person rostered",
    "rostered_other": "{{count}} people rostered",
    "shifts_one": "{{count}} shift",
    "shifts_other": "{{count}} shifts",
    "cancelled": "This event has been cancelled.",
    "minStaff": "Needs {{count}}",
    "need_one": "{{count}} more needed",
    "need_other": "{{count}} more needed",
    "covered": "Covered",
    "nobody": "Nobody confirmed yet.",
    "awaiting_one": "{{count}} awaiting reply",
    "awaiting_other": "{{count}} awaiting reply",
    "noShifts": "No shifts have been added to this event yet.",
    "preparedFor": "Prepared for {{name}}",
    "notFoundTitle": "We couldn’t find this report.",
    "notFoundBody": "Check that the link was copied in full, or ask for the report to be sent again.",
    "expiredTitle": "This report link has expired.",
    "expiredBody": "Ask for the report to be sent again to get a fresh link.",
    "errorTitle": "We couldn’t load the report.",
    "errorBody": "Check your connection and try again."
  }
}
